declare global {
    interface Window {
        tgp?: (...args: unknown[]) => void
    }
}

const REGISTRATION_SUCCESS_EVENT = 'uOHfgAwA-m9BglDkc'

export const TelegramPixel = {
    trackRegistrationSuccess: () => {
        if (typeof window === 'undefined' || !window.tgp) return

        window.tgp('event', REGISTRATION_SUCCESS_EVENT)
    },
}
